module.exports = __webpack_public_path__ + "static/media/dogpark-home.45b9cfd4.jpeg";